import { Component } from "@angular/core";
import { environment } from "../../environments/environment";

/**
 * Reusable "invite a new user" panel. Sits under the user-search inputs
 * (superadmin tab + org/facility Manage Users dialog) and shows a shareable
 * URL that takes a brand-new person straight to the Logto registration screen.
 *
 * The URL points at our own `/admin-login?screen=signup` route (NOT a raw Logto
 * authorize URL) so the recipient's browser initiates the flow and owns the PKCE
 * verifier needed for the callback.
 *
 * Context-agnostic for now; may later tailor the link per entity.
 */
@Component({
  selector: "app-invite-link",
  templateUrl: "./invite-link.component.html",
  styleUrls: ["./invite-link.component.css"],
})
export class InviteLinkComponent {
  copied = false;

  get registerUrl(): string {
    const base = (environment.app_url || "").replace(/\/+$/, "");
    return `${base}/admin-login?screen=signup`;
  }

  copy() {
    navigator.clipboard?.writeText(this.registerUrl).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }
}
